import company from "../../blocks/megasale/company";


if (document.body.classList.contains('events-view-page')) {
    company();
}
